declare global {
	interface Window { strum: Function; }
}

import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from '@angular/platform-browser';

import { CommonFunctionService } from './services/common-function.service';
import { SocketSidekickService } from './services/socket-sidekick.service';
import { ElasticsearchService } from './services/elasticsearch.service';
// Socket connection is moved to azgiv component since it should be connected after logging in
// import { SocketService } from './services/socket.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
	title = 'app';
	public isLoadingSpinner: boolean;
	private isLoadingSpinnerSub: Subscription;

	constructor(
		// private activatedRoute: ActivatedRoute,
		private router: Router,
		private commonFuncService: CommonFunctionService,
		// private elasticsearchService: ElasticsearchService,
		private socketSidekickService: SocketSidekickService,
		matIconRegistry: MatIconRegistry,
		domSanitizer: DomSanitizer
		// private socketService: SocketService
	) {
		matIconRegistry.addSvgIcon(
			'icon-a3i',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_a3i_logo.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-fullscreen-off',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/glyphicons-svg/glyphicons-basic-215-fullscreen-off.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-layers',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/glyphicons-svg/glyphicons-basic-964-layers.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-basic-switch',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/glyphicons-svg/glyphicons-basic-478-switch.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-resize-vertical',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/glyphicons-svg/glyphicons-basic-750-resize-vertical.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-chevron-left',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/glyphicons-svg/glyphicons-basic-223-chevron-left.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-chevron-right',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/glyphicons-svg/glyphicons-basic-224-chevron-right.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-circle-remove',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/glyphicons-svg/glyphicons-basic-633-circle-remove.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-chevron-last-left',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/glyphicons-svg/glyphicons-basic-799-chevron-last-left.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-chevron-last-right',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/glyphicons-svg/glyphicons-basic-800-chevron-last-right.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-address-location',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_address_location.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-address-placement',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_address_placement.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-address-association',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_address_association.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-building-gov',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_building_government.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-building-gov2',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_building_government_2.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-flag',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_flag.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-fishbone',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_fishbone.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-label',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_label_product.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-label-remove',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_label_product_remove.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-layer-state-content',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_alt_page_search.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-layer-state-schema',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_chema_structure.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-layer-state-domain',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_component_element_feature_items.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-map-legend',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_map_legend.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-merge',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_merge.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-paint',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_paint.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-split',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_split.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-topology-ring',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_topology_ring_hierarchy.svg')
		);
		matIconRegistry.addSvgIcon(
			'icon-reverse',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/img/icon_reverse.svg')
		);
		matIconRegistry.addSvgIcon(
			'more-vertical',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/css/glyphicons-svg/glyphicons-basic-498-more-vertical.svg')
		);
	}
		// // Click on page
		// @HostListener('mousedown', ['$event']) onMousedown(e: MouseEvent) {
		// 	this.commonFuncService.onMousedown.next(e);
		// }
	ngOnInit() {
		// Sematext
		this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				window['strum']('routeChange', event.url);
			}
		});
		this.isLoadingSpinnerSub = this.commonFuncService.loadingSpinner.subscribe((isLoading) => {
			this.isLoadingSpinner = isLoading;
		});
		// this.socketService.connectSocket();

		// this.elasticsearchService.isAvailable().then(() => {
		// 	console.log('status ok')
		// }, err => {
		// 	console.log('error', err)
		// })
	}
	ngOnDestroy() {
		this.isLoadingSpinnerSub.unsubscribe();
	}
}
